import { render, staticRenderFns } from "./FavoriteAction.vue?vue&type=template&id=0754aa28&"
import script from "./FavoriteAction.vue?vue&type=script&lang=js&"
export * from "./FavoriteAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports